import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Siren } from "lucide-react";
import { PageHeader, Loading } from "../components/Layout";
import { EmergencyButton, Results } from "../components/EmergencyButton";
import { api, errMsg } from "../lib/api";
import { CITIES } from "./CityPage";

export const AkutIndex = () => (
  <div data-testid="akut-index-page">
    <PageHeader eyebrow="Akut dyrlæge" title="Akut dyrlæge i din by">Find nærmeste døgnåbne dyrehospital og klinikkernes vagttelefoner i de største danske byer – eller brug din placering.</PageHeader>
    <div className="container-vp pt-8"><EmergencyButton testid="akut-index-emergency-button" /></div>
    <ul className="container-vp py-8 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
      {CITIES.map(([s, n]) => <li key={s}><Link to={`/akut-dyrlaege/${s}`} className="card-vp p-4 block font-semibold text-[#153C3A] hover:shadow-md" data-testid={`akut-city-link-${s}`}>Akut dyrlæge {n}</Link></li>)}
    </ul>
  </div>
);

export default function AkutPage() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setD(null);
    setError("");
    api.get(`/seo/akut/${slug}`).then((r) => setD(r.data)).catch((e) => setError(errMsg(e)));
  }, [slug]);
  if (error) return <div className="container-vp py-16 text-[#52706D]" data-testid="akut-error">{error}</div>;
  if (!d) return <Loading />;
  return (
    <div data-testid="akut-page">
      <PageHeader eyebrow={`Akut dyrlæge ${d.name}`} title={`Akut dyrlæge i ${d.name}`}>
        Nærmeste døgnåbne dyrehospitaler og klinikkernes egne vagttelefoner i og omkring {d.name}. Ring altid, før du kører.
      </PageHeader>
      <div className="container-vp py-10 grid lg:grid-cols-[1fr_300px] gap-8">
        <section aria-label={`Akut hjælp i ${d.name}`}>
          <Results data={d} />
          {d.checked && <p className="text-xs text-[#52706D] mt-3" data-testid="akut-checked">Oplysninger hentet fra klinikkernes egne hjemmesider – senest kontrolleret {d.checked}.</p>}
        </section>
        <aside className="space-y-6 text-sm">
          <div className="card-vp p-4">
            <h2 className="font-bold text-[#153C3A] flex items-center gap-2"><Siren className="h-4 w-4 text-[#B42318]" />Er du ikke i {d.name}?</h2>
            <p className="text-[#52706D] mt-1">Find det nærmeste sted ud fra din egen placering.</p>
            <EmergencyButton className="mt-3 w-full" testid="akut-page-emergency-button" />
          </div>
          <div><h2 className="font-bold text-[#153C3A]">Læs også</h2>
            <ul className="mt-2 space-y-1">
              <li><Link to="/guide/derfor-koster-akut-dyrlaege-mere" className="text-[#087F72] hover:underline" data-testid="akut-guide-link">Derfor koster akut dyrlæge mere</Link></li>
              <li><Link to={`/dyrlaege/${d.slug}`} className="text-[#087F72] hover:underline" data-testid="akut-city-page-link">Alle dyrlæger i {d.name}</Link></li>
            </ul></div>
          <div><h2 className="font-bold text-[#153C3A]">Akut dyrlæge i andre byer</h2>
            <ul className="mt-2 grid grid-cols-2 gap-1">{d.others.map((o) => <li key={o.slug}><Link to={`/akut-dyrlaege/${o.slug}`} className="text-[#087F72] hover:underline" data-testid={`akut-other-${o.slug}`}>{o.name}</Link></li>)}</ul></div>
        </aside>
      </div>
    </div>
  );
}
